import { InjectionToken } from '@angular/core';

export const NO_ANALYTICS_TOKEN = new InjectionToken<boolean>('No analytics');
